import { createStyles } from '@mantine/core';
var useStyles = createStyles(function () {
  return {
    externalSystemName: {
      stroke: "#FF0000",
      strokeWidth: "3",
      fontSize: 80
    },
    externalSystemDot: {
      fill: "#FFFFFF",
      stroke: "none",
      pointerEvents: "auto",
      cursor: "pointer"
    },
    pointer: {
      cursor: "pointer"
    },
    neutral: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF"
    },
    amarr: {
      fill: "#E7B815",
      stroke: "#E7B815"
    },
    minmatar: {
      fill: "#FE3743",
      stroke: "#FE3743"
    },
    caldari: {
      fill: "#00ACD1",
      stroke: "#00ACD1"
    },
    gallente: {
      fill: "#40AA5E",
      stroke: "#40AA5E"
    }
  };
});
export { useStyles as default };